import { topProductsByRevenue } from "../../../config/messageconstant";
import {
    COLORS,
    productsTable as ptStyles,
    sectionLabel
} from "../styles/ChallanStyles";
export const ProductsTable = ({ products }) => (
    <>
        <div style={sectionLabel}>{topProductsByRevenue}</div>

        <div style={ptStyles.wrapper}>
            <table style={ptStyles.table}>
                <thead>
                    <tr>
                        <th
                            style={{
                                ...ptStyles.th,
                                textAlign: "left",
                            }}
                        >
                            Product
                        </th>

                        {[
                            "Rate",
                            "Challan Qty",
                            "In Qty",
                            "Out Qty",
                            "Bill Qty",
                            "Total",
                            "Difference",
                            "Bill Revenue",
                            "Sell %",
                        ].map((h) => (
                            <th key={h} style={ptStyles.th}>
                                {h}
                            </th>
                        ))}
                    </tr>
                </thead>

                <tbody>
                    {products.map((p, i) => {

                        const sellDenominator =
                            (Number(p.secondaryQty) || 0) +
                            (Number(p.secondaryInQty) || 0) -
                            (Number(p.secondaryOutQty) || 0);

                        const sellPercentage =
                            Number(p.secondaryBillQty) > 0 && sellDenominator > 0
                                ? (
                                    ((Number(p.secondaryBillQty) || 0) /
                                        sellDenominator) *
                                    100
                                ).toFixed(1)
                                : "0.0";

                        return (
                            <tr
                                key={i}
                                style={{
                                    borderBottom:
                                        i < products.length - 1
                                            ? `1px solid ${COLORS.borderLight}`
                                            : "none",
                                }}
                            >
                                <td
                                    style={{
                                        ...ptStyles.tdName,
                                        textAlign: "left",
                                    }}
                                >
                                    {p.productName}
                                </td>
                                <td style={ptStyles.td}>₹{p.rate.toFixed(2) ?? 0.00}</td>
                                <td style={ptStyles.td}>{p.secondaryQty ?? 0}</td>
                                <td style={ptStyles.td}>{p.secondaryInQty ?? 0}</td>
                                <td style={ptStyles.td}>{p.secondaryOutQty ?? 0}</td>
                                <td style={ptStyles.td}>{p.secondaryBillQty ?? 0}</td>
                                <td style={ptStyles.td}>{p.grandTotalSecQty ?? 0}</td>
                                <td style={ptStyles.td}>{p.secondaryDiffQty ?? 0}</td>

                                <td
                                    style={{
                                        ...ptStyles.td,
                                        fontWeight: 600,
                                    }}
                                >
                                    ₹{p.billAmt.toFixed(2) ?? 0.00}
                                </td>

                                <td
                                    style={{
                                        ...ptStyles.td,
                                        fontWeight: 600,
                                    }}
                                >
                                    {sellPercentage}%
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    </>
);